/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const citySearchRegionDataSchema = z.object({
	id: z.string(),
	name: z.string(),
})

export type CitySearchRegionDataSchema = z.infer<typeof citySearchRegionDataSchema>
